import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Icon from "@material-ui/core/Icon";
import ExcelJS from 'exceljs';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { formatMoney, parseDate } from "utils/Utils";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid , InputLabel } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import ToastModal from "views/components/ToastModal";
export const parseDates = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return date + "-" + month + "-" + dateObj.getFullYear();
};
const useStyles = makeStyles(styles);
const ReportGenerate = (props) => {
  const classes = useStyles();
  const [FromDate, setFromDate] = useState(null);
  const [ToDate, setToDate] = useState(null);

  const [selectedReport, setSelectedReport] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  //goldRate
  const [tableColumnsGoldRate, setTableColumnsGoldRate] = useState([
    "Date",
    "Fineness Code",
    "Lending Rate",
    "Userid",
  ]);
  const [fileGoldRateData, setFileGoldRateData] = useState([]);
  // Application
  const [tableColumnsApplication, setTableColumnsApplication] = useState([
    "Loan Req No",
    "Name",
    "Amount",
    "Address",
    "pinCode",
    "mobileNo",
    "Status(Assign/Pending)",
    "Assign to",
  ]);
  const [fileApplicationData, setFileApplicationData] = useState([]);
  const { authToken } = useSelector((state) => state.login.authData);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);

  };

  const SearchParam = () => {
    let query = "";
    if (ToDate !== null) {
      if (query !== "") query = query + "&";
      query = query + "dateTo=" + parseDate(ToDate);
    }
    if (FromDate !== null) {
      if (query !== "") query = query + "&";
      query = query + "dateFrom=" + parseDate(FromDate);
    }

    return query;
  };
  const GetGoldRateData = async () => {
    const query = SearchParam();
    //ADMIN_GOLDRATE_FINDHISTORY
    const resultgoldRate = await apiHandler({
      url: endpoint.ADMIN_GOLDRATE_FINDHISTORY + "?" + query,
      authToken: authToken,
    });
    if (resultgoldRate.data.error_code) {
      toastUpdate("Error", resultgoldRate?.data?.user_description, true);
    } else {
      setFileGoldRateData(resultgoldRate.data);
      parseIndicatorGoldRateData(resultgoldRate.data);
    }
  };
  const parseIndicatorGoldRateData = (data) => {
    //let reportData = [];
    let fileData = [];
    fileData.push(tableColumnsGoldRate);

    data &&
      data.forEach((goldpay) => {
        fileData.push([
          parseDates(goldpay.createdOn),
          goldpay.purity,
          formatMoney(goldpay.lendingPrice) + " " + goldpay.currencyCode,
          goldpay.createdBy,
        ]);
      });
    styleAndExportExcel(fileData, "ReportGoldRate.xlsx", 4);
  };


  const styleAndExportExcel = async (data, fileName, columnCount) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");
    worksheet.addRows(data);

    worksheet.eachRow((row, rowNumber) => {
      row.alignment = { vertical: 'middle', horizontal: 'left' };
      row.font = { name: 'Calibri' };
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
      if (rowNumber === 1) {
        row.font = { ...row.font, bold: true };
        row.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFDAE2F2' }
        };
      }
    });

    for (let i = 1; i <= columnCount; i++) {
      worksheet.getColumn(i).width = 20;
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };


  const GetReportsapplicationData = async () => {
    //ADMIN_LOANAPPLICATION_FINDSTATUS_SUBITTED
    const loanResultSubmitted = await apiHandler({
      url:
        endpoint.ADMIN_LOANAPPLICATION_FINDSTATUS_SUBITTED +
        "&date=" +
        parseDate(FromDate),
      authToken: authToken,
    });
    //ADMIN_LOANAPPLICATION_FINDSTATUS_ASSIGNED
    const loanResultAssigned = await apiHandler({
      url:
        endpoint.ADMIN_LOANAPPLICATION_FINDSTATUS_ASSIGNED +
        "&date=" +
        parseDate(FromDate),
      authToken: authToken,
    });

    if (
      loanResultSubmitted.data.error_code &&
      loanResultAssigned.data.error_code
    ) {
      toastUpdate("Error", loanResultAssigned?.data?.user_description, true);
    } else {
      const applicationData = [
        ...loanResultSubmitted.data.applications,
        ...loanResultAssigned.data.applications,
      ];
      setFileApplicationData(applicationData);
      parseIndicatorApplicationData(applicationData);
    }
  };
  const parseIndicatorApplicationData = (data) => {
    let fileData = [];
    fileData.push(tableColumnsApplication);
    data &&
      data.forEach((goldpay) => {
        fileData.push([
          goldpay.loanRequestNum,
          goldpay.branchName,
          goldpay.proposedLoanAmt,
          goldpay.address,
          goldpay.pincode,
          goldpay.mobileNumber?.trim(),
          goldpay.status,
          goldpay.agentName,
        ]);
      });
    styleAndExportExcel(fileData, "ReportApplication.xlsx", 8);
  };

  const GenerateResultData = () => {
    switch (selectedReport) {
      case "GOLD_RATE":
        return GetGoldRateData();
      case "Application":
        return GetReportsapplicationData();
    }
    // }
  };

  const clearData = () => {
    setFromDate(null);
    setToDate(null);
  };
  const selectReportType = (e, type) => {
    setSelectedReport(type);
  };
  return (
    <div>
      <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Reports"
          button1="Generate"
          button2="Clear"
          button1click={GenerateResultData}
          button2click={clearData}
        />
      </Grid></Grid>
      <GridContainer>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div style={{ fontWeight: "bold" }}>
            {" "}
            <input
              id="Part"
              type="radio"
              name="report"
              className="custom-control-input"
              onChange={(e) => selectReportType(e, "GOLD_RATE")}
            />{" "}
            GoldRate{" "}
          </div>
        </GridItem>
        <GridItem xs={4} sm={4} md={4} lg={4} style={{ textAlign: "start" }}>
          <div style={{ fontWeight: "bold" }}>
            {" "}
            <input
              id=" Receipt"
              type="radio"
              name="report"
              className="custom-control-input"
              onChange={(e) => selectReportType(e, "Application")}
            />{" "}
            Application{" "}
          </div>
        </GridItem>
        <GridItem
          xs={4}
          sm={4}
          md={4}
          lg={4}
          style={{ textAlign: "start", marginTop: 10 }}
        ></GridItem>
        {selectedReport === "GOLD_RATE" && (
          <>
             <GridItem
            xs={12}
            sm={12}
            md={4}
            lg={4}
            style={{ textAlign: "start" }}
          >
            <InputLabel
              className={classes.labelRoot}
              style={{ textAlign: "left" }}
              >
              From Date
              </InputLabel>
              <CustomeDateCalender
                handleDateChange={setFromDate}
                selectedDate={FromDate}
                id="from_date"
              />
            </GridItem>



            <GridItem xs={2} sm={2} md={2} lg={2}></GridItem>
            <GridItem
               xs={12}
               sm={12}
               md={4}
               lg={4}
               style={{ textAlign: "start" }}
             >
               <InputLabel
                 className={classes.labelRoot}
                 style={{ textAlign: "left" }}
>
From To
</InputLabel>
            <CustomeDateCalender
              handleDateChange={setToDate}
              selectedDate={ToDate}
              id="to_date"
            />

            </GridItem>
            <GridItem
              xs={2}
              sm={2}
              md={2}
              lg={2}
              style={{ textAlign: "start", marginTop: 10 }}
            ></GridItem>
          </>
        )}
        {selectedReport === "Application" && (
          <>
               <GridItem
            xs={12}
            sm={12}
            md={4}
            lg={4}
            style={{ textAlign: "start" }}
          >
            <InputLabel
              className={classes.labelRoot}
              style={{ textAlign: "left" }}
              >
              From Date
              </InputLabel>
              <CustomeDateCalender
                handleDateChange={setFromDate}
                selectedDate={FromDate}
                id="from_date"
              />
            </GridItem>

            <GridItem xs={2} sm={2} md={2} lg={2}></GridItem>
          </>
        )}
      </GridContainer>
      <GridContainer>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      </GridContainer>
    </div>
  );
};

export default ReportGenerate;
